module.exports = __webpack_public_path__ + "46a5b4ac1d7c8b3104ed8e21a655fda4.jpg";